module.exports = __webpack_public_path__ + "static/media/pit_0.7b20b96c.png";